import Vuex from 'vuex';

// Import store modules to use in the footer component
import ContentStoreModule from '../content/store/ContentStoreModule';

// Create custom store comprised of required sub-modules
export function getStore(){
    return new Vuex.Store({modules: {content: ContentStoreModule}});
}
